<template>
  <b-dropdown
    id="language-selector"
    :text="$store.state.common.availableLangs[$store.state.common.lang]"
    :title="$t('select lang')"
    class="m-md-2"
    :variant="variant"
    :size="size"
    menu-class="w-100"
  >
    <template v-for="(lang, lang_code) in $store.state.common.availableLangs">
      <b-dropdown-item v-if="$store.state.common.lang == lang_code" disabled>
        {{ lang }}
      </b-dropdown-item>
      <b-dropdown-item v-else @click="$root.setLanguage(lang_code)">
        {{ lang }}
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<script>
export default {
  name: 'LanguageSelector',
  mixins: [],
  props: {
    variant: {
      type: String,
      default: 'secondary',
      required: false
    },
    size: {
      type: String,
      default: '',
      required: false
    }
  },
  components: {},
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
